import {handleLogout} from "components/utils";
import React, {useEffect, useRef, useState} from 'react';
import {
    DatatableWrapper,
    Filter,
    Pagination,
    PaginationOptions,
    TableBody,
    TableColumnType,
    TableHeader
} from "react-bs-datatable";
import {Button, Col, Modal, Row, Tab, Table, Tabs} from "react-bootstrap";
import axios from "axios";
import {ConsentFormView} from "../ConsentFormView";
import {ConsentFormPrintView} from "./ConsentFormPrintView";
import {random} from "nanoid";
import ReactToPrint from "react-to-print";
import {ConsentFormPreviewView} from "../ConsentFormPreviewView";

export const CaseConsentFormsView = (props: { cookieEntityQr: string, caseDetails: any, dischargeDate }) => {
    const [items, setItems] = useState<Array<string>>([]);

    function fetchItems() {
        axios.get('/api/backend/form/template/fetch/all/' + props.cookieEntityQr)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                if (resp.data) {
                    setItems(resp.data)
                }
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
            })
    }

    useEffect(() => {
        fetchItems()
    }, [props.cookieEntityQr])

    const [itemId, setItemId] = useState<string>();
    const [showItemPreviewModal, setShowItemPreviewModal] = useState(false);
    const handleCloseItemPreviewModal = () => setShowItemPreviewModal(false);
    const handleShowItemPreviewModal = (itemId) => {
        setItemId(itemId)
        setShowItemPreviewModal(true)
    }

    function getModalForItemPreview() {
        return <Modal
            show={showItemPreviewModal}
            onHide={handleCloseItemPreviewModal}
            backdrop="static"
            className="modal-xl"
        >
            <Modal.Header closeButton/>
            <Modal.Body>
                <ConsentFormPrintView id={itemId} entityQr={props.cookieEntityQr} caseDetails={props.caseDetails}
                                      dischargeDate={props.dischargeDate}/>
            </Modal.Body>
        </Modal>;
    }

    const ITEMS_HEADERS: TableColumnType<any>[] = [
        {
            prop: "name",
            title: "Name",
            isFilterable: true,
            isSortable: true
        },
        {
            prop: "button",
            cell: (row) => (
                <><a href="#/" className="edit text-primary"
                       onClick={() => handleShowItemPreviewModal(row.id)}><img
                    alt="session-management"
                    src="/emr/preview_icon.png"
                    width="30"
                    height="30"
                />&nbsp;&nbsp;Preview</a></>
            )
        }
    ];

    function getItemsTable() {
        return <div className="overflow-scroll"><DatatableWrapper
            body={items}
            headers={ITEMS_HEADERS}
            paginationOptionsProps={{
                initialState: {
                    rowsPerPage: 30,
                    options: [30, 50, 100]
                }
            }}
        >
            <Row className="mb-4 p-2">
                <Col
                    xs={12}
                    lg={4}
                    className="d-flex flex-col justify-content-end align-items-end"
                >
                    <Filter/>
                </Col>
                <Col
                    xs={12}
                    sm={6}
                    lg={4}
                    className="d-flex flex-col justify-content-lg-center align-items-center justify-content-sm-start mb-2 mb-sm-0"
                >
                    <PaginationOptions/>
                </Col>
                <Col
                    xs={12}
                    sm={6}
                    lg={4}
                    className="d-flex flex-col justify-content-end align-items-end"
                >
                    <Pagination/>
                </Col>
            </Row>
            <Table>
                <TableHeader/>
                <TableBody/>
            </Table>
            <Row className="mt-4 p-2">
                <Col
                    xs={12}
                    sm={12}
                    lg={12}
                    className="d-flex flex-col justify-content-end align-items-end"
                >
                    <Pagination/>
                </Col>
            </Row>
        </DatatableWrapper>
        </div>;
    }

    return (
        <>
            <div className="row my-5">
                <div className="col">
                    <div className="card p-2 shadow-sm">
                        <div className="d-flex justify-content-between py-2 pr-1">
                            <h4 className="text-primary pl-1">Consent Forms</h4>
                        </div>
                        {getItemsTable()}
                        {getModalForItemPreview()}
                    </div>
                </div>
            </div>
        </>
    );
};
